// Reportes generados antes de SWSMTR-2897 quedaron guardados con el typo
// "Ingesos" (debía ser "Ingresos"). El dato ya está persistido tal cual, así
// que se corrige aquí en la capa de presentación. Se reemplaza la palabra
// suelta (sin exigir coincidencia exacta del string completo) porque el
// formato exacto del prefijo/espaciado varía entre reportes viejos.
const fixCfdiTypeLabel = type =>
    typeof type === 'string' ? type.replace(/Ingesos/i, 'Ingresos') : type;

export const generalData = data  => {
    let newData = data.map((item, index) => {
            return {
                'name': fixCfdiTypeLabel(item.type),
                'value': item.numberOfCfdis
            }
    });

    return newData;
}

export const invoicesTotal  = data  => {   
    let newData = data.map((item, index) => {   
        return {
            'name': item.label,
            'Cantidad': item.totalAmount,
            'Total': item.totalMoney
        }
    }); 

    return newData;
}

export const efosTotal  = data  => {   
    let newData = data.map((item, index) => {   
        return {
            'name': item.situation,
            'value': item.total,
        }
    });  
      
    return newData;
}